import { Box, Flex, Image, Text } from "@chakra-ui/react";
import React from "react";

const Empty = () => {
  return (
    <Flex
      align="center"
      pos="relative"
      backgroundColor="#FFFFFF"
      boxShadow="0px 0px 1px rgba(0, 0, 0, 0.5)"
      borderRadius="8px"
      w="100%"
      p="8px"
      cursor="pointer">
      <Box backgroundColor="blue.500" p="4px" borderRadius="8px" mr="10px" minW="46px">
        <Image src="/video_camera.png" height="40px" />
      </Box>

      <Box overflow="auto">
        <Text fontWeight="700" color="gray.500" fontSize="md" lineHeight="18px" isTruncated>
          No sessions scheduled
        </Text>
        <Text fontWeight="700" fontSize="sm" color="blue.500" isTruncated></Text>
      </Box>
    </Flex>
  );
};

export default Empty;
